import { ReqMap } from '../tools/interfaces/req-map';

export const Requests: ReqMap = {
  getOwner: { url: '/@me', method: 'GET' },
};

export const ACCOUNT_SPINNER_NAME: string = 'acc-content-spinner';
